import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  forwardRef,
} from 'react';

import styles from './style.module.scss';

type Props = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const Checkbox = forwardRef<HTMLInputElement, Props>((props, ref) => {
  return (
    <div className={styles['root']}>
      <input {...props} ref={ref} className={styles['input']} />
      <span className={styles['checkbox']} />
    </div>
  );
});

Checkbox.displayName = 'Checkbox';
